/* eslint-disable no-lone-blocks */
import React, { useLayoutEffect, useState, useEffect, useRef, Fragment, useCallback } from 'react'
import { SelectBox, Button, TextBox, CheckBox, TextArea, DateBox, FileUploader } from "devextreme-react";
import JoditEditor from 'jodit-react';
import Swal from 'sweetalert2';
import debounce from 'lodash/debounce';
import Popup from "devextreme-react/popup";
import { IOMService } from '../../../apis/apiServices/InterOfficeMemo(IOM)'
import { ProjectService } from '../../../apis/apiServices/Project'
import { getUserDropdown } from '../../../apis/apiServices/User'
import { getUserDropdownForIom } from '../../../apis/apiServices/User'
import { getIOMToUsersDropdown } from '../../../apis/apiServices/User'
import { DepartmentService } from '../../../apis/apiServices/Department'
import { getFormCategoryDropDown } from '../../../apis/apiServices/FormCategory';
import { GetWorkFlowForApprovalForIom } from '../../../apis/apiServices/WorkFlow';
import { getFormTypeDropdown } from '../../../apis/apiServices/FormType';
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { CategoryService } from '../../../apis/apiServices/Category'
import { Loader } from '../../Shared/PageLoader';
import { v4 as uuidv4 } from 'uuid';
import { getReduxCompany } from '../../../helper/sessionHelper';
import { Icon } from "@iconify/react";

export default function NewIOMComponentV2(props) {
    const location = useLocation();
    const iomDataList = location.state;
    useLayoutEffect(() => {
        const titleElement = document.querySelector("#pageTitle");
        if (titleElement) {
            if (!iomDataList) {
                titleElement.innerHTML = "New IOM - Inter Office Memorandum";
            } else {
                titleElement.innerHTML = "Update IOM - Inter Office Memorandum"
            }
        }
        if (!iomData?.iomId) {
            getProjectDropdownData();
        }

        getUserDropdownData();
        getRecommendUserDropdownData();
        getApproveUserDropdownData();
        getDepartmentDropdown();
        getToUserDropdownData();
        // getIOMFormCategoryByFormId();
        //getCategoryDropdown();
        getIOMAttachmentsByIOMId(iomDataList?.iomId);
        getIOMDetailsForEdit(iomDataList?.iomId);
    }, []);

    const navigate = useNavigate();
    const editor = useRef(null);
    const [content, setContent] = useState(null);
    const user = useSelector((state) => state.user.data);
    const [projectDropdownData, setProjectDropdownData] = useState(null);
    const [approvalLabels, setApprovalLabels] = useState({});
    const [iomData, setIOMData] = useState([]);
    const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
    const [userDropdownData, setUserDropdownData] = useState([]);
    const [toUserDropdownData, setToUserDropdownData] = useState([]);
    const [departmentDropdownData, setDepartmentDropdownData] = useState([]);
    const [formCategoryDropdownData, setFormCategoryDropdownData] = useState([]);
    const [iomApproversByWorkflow, setIOMApproversByWorkflow] = useState([]);
    const [iomApprovers, setIOMApprovers] = useState([]);
    const [workflowData, setWorkflowData] = useState([]);
    const [recommendUserDropdownData, setRecommendUserDropdownData] = useState({});
    const [approveUserDropdownData, setApproveUserDropdownData] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [departmentUserDropdownData, setDepartmentUserDropdownData] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [files, setFiles] = useState([]);
    const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});


    const [departmentError, setDepartmentError] = useState('');
    const [userError, setUserError] = useState('');
    const [userApprovers, setUserApprovers] = useState([])
    const [iom, setIom] = useState({
        toUserId: "",
        // toUserIds: [],
        toUserIds: 0,
        verifyAndRecommendedUserIds: [],
        subject: "",
        projectId: 0,
        categoryId: 0,
        departmentId: 0,
        iomDate: "",
        iomMessage: "",
        content: "",
        recommended_By: "",
        ddl_approver: 5,
        iomId: "",
        approvalStage: 0,
        approvers: {},
    });

    const [loading, setLoading] = useState(false)

    const getIOMDetailsForEdit = async (iomId) => {
        // debugger
        try {
            let body = {
                UserId: 0,
                IomId: iomId,
                projectId: 0,
                iomStatusId: 0,
                fromDate: null,
                toDate: null,
            }
            const response = await IOMService.getIomDetailForEdit(body);
            setIOMData(response?.data[0]);
            // getFilteredList([8, 4], response?.data)
            return response?.data;
        } catch (error) {
            console.log("Error getIOMList===>", error);
        }
    }

    const setIOMDataForEdit = async () => {
        let approvers = iomData?.approvers || [];
        approvers = (approvers && approvers?.length) ? approvers?.filter(approver => approver?.statusId !== 1) : []

        const approverResults = await Promise.all(
            approvers.map(async (approver, key) => {
                return {
                    approverData: {
                        UserDesignationId: approver?.designationId,
                        UserId: approver?.userId,
                        UserName: `${approver?.firstName} ${approver?.lastName} (${approver?.designationName})`,
                        StatusId: approver?.statusId,
                        //fieldKey,
                        last: false
                    },
                };
            })
        );

        // Batch update state to avoid multiple re-renders
        const updatedApprovers = approverResults.map(result => result?.approverData);

        const newLabels = approverResults.reduce((acc, { labelKey, labelValue }) => {
            acc[labelKey] = labelValue;
            return acc;
        }, {});

        setApprovalLabels(prev => ({
            ...prev,
            ...newLabels,
        }));

        setUserApprovers(updatedApprovers);
        //setUserApprovers(iomData?.Approvers);
        setProjectDropdownData([{ id: iomData?.projectId, name: iomData?.projectName }]);
        setIom(prevState => ({
            ...prevState,
            toUserIds: iomData?.toUserId || [],
            subject: iomData?.subject,
            projectId: iomData?.projectId,
            iomDate: iomData?.iomDate,
            recommended_By: iomData?.recommendId,
            ddl_approver: iomData?.approverId,
            iomId: iomData?.iomId,
            categoryId: iomData?.iomCategoryId,
            departmentId: iomData?.fromDeptId
            //approvers: updatedApprovers,
        }));
        //GetWorkFlowForApprovers(iomData?.iomCategoryId, iomData?.projectId)

        setContent(iomData?.iomContent);
    };

    useEffect(() => {
        if (iomData) {
            setIOMDataForEdit();
        }
    }, [iomData]);
    useEffect(() => {
        //debugger
        // GetWorkFlowForApprovers(iomData?.iomCategoryId, iomData?.projectId, iomData?.fromDeptId)
        if (iomDataList?.iomId) {
            const stagesWithApprovers = iomData?.approvers
                ?.map(stage => ({
                    actionTypeName: stage?.statusName?.trim() + ' ' + "By",
                    designationName: stage?.designationName,
                    userName: stage?.firstName + " " + stage?.lastName,
                }));
            setIOMApproversByWorkflow(stagesWithApprovers);
            const Approvers = iomData?.approvers?.map(approver => ({
                actionTypeId: approver?.statusId,
                userId: approver?.userId,
                canEdit: approver?.canEdit,
                stageId: approver?.stageId,
            }))
                ;
            setIOMApprovers(Approvers);
            //GetWorkFlowForApprovers(iomData?.iomCategoryId, iomData?.projectId, iomData?.fromDeptId)
        }
        else {
            GetWorkFlowForApprovers(iom?.categoryId, iom?.projectId, user?.userDepartmentId)
        }
        // }, [iomData?.projectId, iomData?.iomCategoryId, iomData?.fromDeptId]);
    }, [iomData?.projectId, iomData?.iomCategoryId, iomData?.fromDeptId]);

    useEffect(() => {
        if (iomDataList?.iomId) {
            // const stagesWithApprovers = iomData?.approvers
            //     ?.map(stage => ({
            //         actionTypeName: stage?.statusName?.trim() + ' ' + "By",
            //         designationName: stage?.designationName,
            //         userName: stage?.firstName + " " + stage?.lastName,
            //     }));
            // setIOMApproversByWorkflow(stagesWithApprovers);
            //GetWorkFlowForApprovers(iomData?.iomCategoryId, iomData?.projectId, iomData?.fromDeptId)
        }
        else {
            GetWorkFlowForApprovers(iom?.categoryId, iom?.projectId, user?.userDepartmentId)
        }
        // GetWorkFlowForApprovers(iom?.categoryId, iom?.projectId, user?.userDepartmentId)
    }, [iom?.projectId, iom?.categoryId, user?.userDepartmentId]);

    useEffect(() => {
        getCategoryDropdown(iom?.projectId, (!iomData?.iomId) ? user?.userDepartmentId : iom?.departmentId)
    }, [iom?.projectId]);

    const config = {
        //readonly: false,
        toolbarSticky: false,
        uploader: {
            insertImageAsBase64URI: true, // Allows embedding image as base64
        },
        allowDragAndDropFileToEditor: true,
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', 'eraser', '|',
            'ul', 'ol', 'indent', 'outdent', '|',
            'font', 'fontsize', 'paragraph', '|',
            'classSpan', 'lineHeight', '|',
            'image', 'file', 'video', 'table', '|',
            'link', 'hr', '|',
            'left', 'center', 'right', 'justify', '|',
            'brush', 'cut', 'copy', 'paste', '|',
            'undo', 'redo', '|',
            'fullsize', 'preview', 'print', 'source', 'superscript', 'subscript', 'symbols'
        ],
        extraButtons: [
            {
                name: '₹',
                icon: '₹',
                exec: (editor) => {
                    editor.selection.insertHTML('₹');
                },
                tooltip: 'Insert Rupee Symbol'
            }
        ]
    };

    const handleFormData = (key, value) => {
        setIom((prevState) => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const pad = (n) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const getUserDropdownData = async () => {
        //debugger;
        try {
            let body = { LevelId: 0 } // LevelId: 6
            const response = await getUserDropdown(body)
            setUserDropdownData(response);
        } catch (error) {
            console.log("Error getUserDropdown===>", error);
        }
    }

    const getToUserDropdownData = async () => {
        try {
            // let body = { LevelId: 0 } // LevelId: 6
            const response = await getIOMToUsersDropdown()
            // Filter out the entry where id matches user.userId
            const filteredResponse = response.filter(item => item?.id !== user?.userId);
            setToUserDropdownData(filteredResponse);
        } catch (error) {
            console.log("Error getUserDropdown===>", error);
        }
    }

    const getRecommendUserDropdownData = async () => {
        //debugger;
        try {
            let body = { LevelGreaterThan: user?.levelId || 0 }
            const response = await getUserDropdown(body)
            setRecommendUserDropdownData(response);
        } catch (error) {
            console.log("Error getUserDropdown===>", error);
        }
    }

    const getApproveUserDropdownData = async () => {
        try {
            let body = {}
            // let body = { LevelGreaterThan: user?.levelId || 0 }
            const response = await getUserDropdown(body)
            setApproveUserDropdownData(response);
        } catch (error) {
            console.log("Error getUserDropdown===>", error);
        }
    }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }

    const getDepartmentDropdown = async () => {
        try {
            const response = await DepartmentService.getDepartmentDropdown()
            setDepartmentDropdownData(response?.data);
        } catch (error) {
            console.log("Error getDepartmentDropdown===>", error);
        }
    }

    const getUsersByDepartmentId = async (departmentId) => {
        let request = {
            DepartmentId: departmentId,
            UserIdsNotIn: [
                user.userId || 0,
                ...(Array.isArray(iom?.toUserIds)
                    ? iom?.toUserIds
                    : iom?.toUserIds !== undefined
                        ? [iom?.toUserIds]
                        : []),
                // ...(iom?.toUserIds || []),
                // (typeof (iom?.toUserIds) === Number)? iom?.toUserIds : ...(iom?.toUserIds  || []),
                ...userApprovers?.map((item) => item?.UserId) || [0]
            ],
            LevelGreaterThan: user?.levelId
        }
        //alert(JSON.stringify(request?.UserIdsNotIn))
        try {
            const response = await getUserDropdownForIom(request)
            setDepartmentUserDropdownData(response?.data);
        } catch (error) {
            console.log("Error getUsersByDepartmentId===>", error);
        }
    }

    const getIOMAttachmentsByIOMId = async (iomId) => {
        //debugger
        try {
            const response = await IOMService.getIOMAttachmentsByIomId(iomId)
            let arr = []
            response?.data?.map((item, key) => {
                let obj = {
                    attachmentId: item?.attachmentId,
                    filePath: item?.filePath,
                    name: item?.iomFileName,
                    size: item?.fileSize,
                    type: item?.fileType
                }
                arr.push(obj)
            })
            setFiles(arr);

        } catch (error) {
            console.log("Error getIOMAttachmentsByIOMId===>", error);
        }
    }

    // const getIOMFormCategoryByFormId = async () => {
    //     try {
    //         let body = {
    //             featureId: 71,
    //             moduleId: 0,
    //             applicationId: 2,
    //             formTypeId: 0
    //         }
    //         const response = await getFormTypeDropdown(body)
    //         setFormCategoryDropdownData(response);
    //     } catch (error) {
    //         console.log("Error getIOMFormCategoryByFormId===>", error);
    //     }
    // }

    // const getCategoryDropdown = async () => {
    //     try {
    //         const response = await CategoryService.getCategoryDropdown()
    //         setFormCategoryDropdownData(response?.data);
    //     } catch (error) {
    //         console.log("Error getCategoryDropdown===>", error);
    //     }
    // }

    const getCategoryDropdown = async (projectId, departmentId) => {
        try {
            let body = { projectId: projectId, departmentId: departmentId }
            const response = await CategoryService.getIOMCategoryDropdown(body)
            setFormCategoryDropdownData(response?.data);
        } catch (error) {
            console.log("Error getCategoryDropdown===>", error);
        }
    }

    const GetWorkFlowForApprovers = async (formCategoryId, projectId, departmentId) => {
        // alert("488734")
        try {
            // user?.userDepartmentId
            let body = { formId: 71, formTypeId: formCategoryId || 0, projectId: projectId || 0, departmentId: departmentId || 0 }
            const response = await GetWorkFlowForApprovalForIom(body)
            setWorkflowData(response);
            const stagesWithApprovers = response?.stages
                ?.filter(stage => stage?.approvers && stage?.approvers?.length > 0)
                ?.map(stage => ({
                    actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
                    approvers: stage?.approvers
                }));
            const Approvers = response?.stages
                ?.filter(stage => stage?.approvers && stage?.approvers?.length > 0)
                ?.flatMap(stage =>
                    stage?.approvers?.map(approver => ({
                        actionTypeId: stage?.actionTypeId,
                        userId: approver?.userId,
                        canEdit: approver?.canEdit,
                        stageId: stage?.index,
                    }))
                );
            setIOMApprovers(Approvers);
            setIOMApproversByWorkflow(stagesWithApprovers);
            // console.log(Approvers);
        } catch (error) {
            console.log("Error getDepartmentDropdown===>", error);
        }
    }


    const validateForm = () => {
        let isValid = true;
        let err = {};

        if (!iom?.subject) {
            err.subject = "Please enter subject";
            isValid = false;
        }
        else { err.subject = ""; }
        if (!iom?.projectId) {
            err.projectId = "Please select project";
            isValid = false;
        }
        else { err.projectId = ""; }

        if (!iom?.categoryId) {
            err.categoryId = "Please select category";
            isValid = false;
        }
        else { err.categoryId = ""; }

        if (content === "<p>&nbsp;<br></p>" || content === "" || content === "<p><br></p>") {
            err.iomMessage = "Please enter content";
            isValid = false;
        }
        else { err.iomMessage = ""; }
        //console.log('err', err)
        setErrors(err);
        return isValid;
    }


    const handleSubmit = () => {
        if (!remarks) {
            setError("Please enter remark");
            return;
        }
        setError("");
        setIsModalVisible(false);

        let iomStatus = 8 //updated save as draft
        let currentIOMStatusId = iomData?.iomStatusId;
        //console.log("currentIOMStatusId", currentIOMStatusId)
        addNewIoM(iomData?.nextUserId === user?.userId ? currentIOMStatusId : iomStatus);  // Now call your existing function
    };

    const handleUpdateSubmit = () => {
        if (!remarks) {
            setError("Please enter remark");
            return;
        }
        setError("");
        setIsUpdateModalVisible(false);
        addNewIoM(5);  // Now call your existing function
    };

    //Attachments
    const MAX_FILE_SIZE = 30 * 1024 * 1024;
    const TOTAL_FILE_SIZE_LIMIT = 300 * 1024 * 1024;

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e?.target?.files); // Convert FileList to Array
        if (files.length + selectedFiles.length > 10) {
            Swal.fire("Warning", `You can upload maximum ${10} files.`, "warning")
            e.target.value = ""; // reset input
            return;
        }
        // Validate file size
        const validFiles = [];
        for (let file of selectedFiles) {
            if (Number(file.size) > MAX_FILE_SIZE) {

                Swal.fire("Warning", `"${file.name}" exceeds 30MB limit.`, "warning");
                e.target.value = ""; // reset input
                return;
            } else {
                validFiles.push(file);
            }
        }
        // size of files already in state
        const existingSize = files.reduce(
            (sum, file) => sum + Number(file.size),
            0
        );

        // size of newly selected files
        const newFilesSize = validFiles.reduce(
            (sum, file) => sum + Number(file.size),
            0
        );

        const totalSize = Number(existingSize) + Number(newFilesSize);

        //console.log("existingSize--", totalSize);
        if (Number(totalSize) > TOTAL_FILE_SIZE_LIMIT) {
            Swal.fire("Warning", `Total size of files exceeds 300MB limit.`, "warning");
            return;
        }
        // console.log("existingSize--", existingSize);
        // console.log("newFilesSize--", newFilesSize);
        // console.log("totalSize--", totalSize);

        setFiles(prev => [...prev, ...validFiles]);

        // setFiles(prevState => [...prevState, ...selectedFiles]);
    };

    const handleFileRemove = (index) => {
        let attachmentToRemove = files?.find((_, i) => i === index)

        setFiles((prev) => prev?.filter((_, i) => i !== index));

        if (attachmentToRemove?.attachmentId) {
            setRemovedAttachmentIds(prevState => {
                let previousIds = prevState || [];
                return [
                    ...previousIds,
                    attachmentToRemove?.attachmentId || 0
                ]
            });
        }
    };

    const addNewIoM = async (iomStatus) => {
        if (!validateForm()) return false;
        try {
            const lastUserId = iomApprovers[Object?.keys(iomApprovers)?.pop()]?.userId;
            const lastUserStageId = iomApprovers[Object?.keys(iomApprovers)?.pop()]?.stageId;
            var requestFormData = new FormData();
            requestFormData.append("IOMStatusId", iomStatus);
            //requestFormData.append("To", [ddl_ToEmail?.selected?.id ?? 0]);
            requestFormData.append("toList", JSON.stringify([lastUserId] ?? []));
            requestFormData.append("WorkFlowId", iomData?.iomId ? iomData?.workFlowId : workflowData?.id ?? 0);
            // requestFormData.append("FromDeptId", iom?.departmentId ?? 0);
            requestFormData.append("FromDeptId", user?.userDepartmentId ?? 0);
            requestFormData.append("Subject", iom?.subject ?? '');
            requestFormData.append("ProjectId", iom?.projectId ?? 0);
            requestFormData.append("CategoryId", iom?.categoryId ?? 0);
            requestFormData.append("SerialNo", "101");
            requestFormData.append("IomDate", formatDate(iom?.iomDate) ?? null);
            requestFormData.append("Message", content ?? "");
            requestFormData.append("CreatedBy", iomApprovers?.[0]?.actionTypeId === 8 ? iomApprovers?.[0]?.userId : user?.userId);
            //requestFormData.append("ApprovedBy", iom?.ddl_approver || 0);
            requestFormData.append("ApprovedBy", lastUserId || 0);
            requestFormData.append("LastUserStageId", lastUserStageId || 0);
            requestFormData.append("IomId", iom?.iomId);
            requestFormData.append("IsManual", false);
            requestFormData.append("IOMFeatureId", props?.featurePermission?.featureId);
            requestFormData.append("CompanyId", getReduxCompany()?.companyId || 1);
            // StatusId: approvalLabels?.[fieldKey] === "Recommend By" ? 2 : approvalLabels?.[fieldKey] === "Verified By" ? 7 : 0
            {
                iomData?.iomId && requestFormData.append("Remarks", remarks ?? '');
                iomData?.iomId && requestFormData.append("RemovedAttachmentIdsJson", JSON.stringify(removedAttachmentIds ?? []))
            }

            let approversCount = Object.entries(iomApprovers, {}).length;
            const resultArray = Object.values(iomApprovers || {})
                ?.filter((fItem, fIndex) => (approversCount !== (fIndex + 1) && fItem?.actionTypeId !== 8))
                ?.map(item => ({
                    userId: item?.userId,
                    statusId: item?.actionTypeId,
                    canEdit: item?.canEdit,
                    stageId: item?.stageId
                }));
            requestFormData.append("ApproversJSON", JSON.stringify(resultArray));

            files.forEach((file) => {
                requestFormData.append("Documents", file);
            });

            setLoading(true)
            const response = (iom?.iomId)
                ? await IOMService.updateIom(requestFormData)
                : await IOMService.createInterOfficeMemorandumV2(requestFormData);
            setLoading(false)
            if (response?.isSuccess) {

                Swal.fire("", response?.message, "success")
                    .then(() => {
                        navigate(-1);
                    }).then(() => {
                        if (user?.isIframe) {
                            window.parent.postMessage(
                                { type: "CLOSE_IFRAME" },
                                process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
                            );
                            return;
                        }
                    });
            } else {
                Swal.fire("Error", response?.message, "error")
            }
        } catch (error) {
            console.log("Error addNewIoM===>", error);
        }
    };

    const handleSubmitApprover = async () => {
        let valid = true;

        if (!iom?.departmentId) {
            setDepartmentError('Please select a department');
            valid = false;
        } else {
            setDepartmentError('');
        }

        if (!iom?.departmentUserId) {
            setUserError('Please select a user');
            valid = false;
        } else {
            setUserError('');
        }

        if (!valid) return;
        const myId = uuidv4();
        let fieldKey = `approved_By_${myId}`

        const tempObj = {
            UserId: iom?.departmentUserId,
            UserName: iom?.departmentUserName,
            UserDesignationId: iom?.userDesignationId,
            fieldKey: fieldKey
        };

        const response = await IOMService.checkUserDesignationForIOMApproval(tempObj?.UserDesignationId);
        const isRecommended = response?.data === true;

        setApprovalLabels(prevLabels => ({
            ...prevLabels,
            fieldKey: isRecommended ? "Recommended By" : "Verified By",
            [fieldKey]: isRecommended ? "Recommended By" : "Verified By",
        }));

        // Add new approver immutably
        setUserApprovers(prev => {
            const newList = [...prev, tempObj];
            return newList;
        });
        setShowPopup(false);
    };

    const handleRemoveApprover = (indexToRemove) => {
        const updatedApprovers = userApprovers.filter((_, idx) => idx !== indexToRemove);
        setUserApprovers(updatedApprovers);

        let key = updatedApprovers?.fieldKey;
        setApprovalLabels(prevState => {
            const newState = { ...prevState };
            delete newState[key];
            return newState;
        });
        //setApprovalLabels(null);
    };


    const handleEditorChange = useCallback(
        debounce((newContent) => setContent(newContent), 300),
        []
    );
    const toUserIdsError = !iom?.toUserIds || iom?.toUserIds?.length === 0;

    //console.log("iomApproversByWorkflow", iomApproversByWorkflow)
    // debugger
    //console.log("iomApprovers", iomApprovers)
    const getButtonText = () => {
        if (!Array.isArray(iomApprovers) || iomApprovers?.length === 0) return "Send";

        const actionTypeId = iomApprovers[0]?.actionTypeId;

        if (actionTypeId === 2) return "Send for Recommendation";
        if (actionTypeId === 7) return "Send for Verification";

        return "Send";
    };
    return (
        <Fragment>
            <div className="content">
                <div className="card card-primary">
                    <div className="card-header">
                        <div className='row align-items-center'>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <h3 className="card-title text-primary">
                                    {iomData?.iomId &&
                                        <span>
                                            <span style={{ backgroundColor: '#282c7d', color: '#ffffff', borderRadius: '0.3rem', padding: '0.2rem 0.5rem' }}>IOM No. {iomData?.serial_no}</span>&nbsp;
                                        </span>}
                                    From - {user?.userDepartmentName} Department</h3>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Cancel"
                                    icon="close"
                                    onClick={() => {
                                        debugger;
                                        if (user?.isIframe) {
                                            window.parent.postMessage(
                                                { type: "CLOSE_IFRAME" },
                                                process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
                                            );
                                            return;
                                        }
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Cancel'
                                    visible={!user?.isIframe}
                                />
                                {/* Save as draft */}
                                {(iomData?.iomStatusId === 8 || !iom?.iomId) &&
                                    <Button
                                        text="Save as Draft"
                                        icon="save"
                                        onClick={(e) => {
                                            //debugger;
                                            let iomStatus = 8
                                            addNewIoM(iomStatus)
                                        }}
                                        stylingMode="contained"
                                        type="default"
                                        hint='Save as Draft'
                                    />
                                }

                                {/* Save button when iom created user edit the iom */}
                                {
                                    iomData?.createdByUserId === user?.userId && iomData?.iomStatusId === 4 ?
                                        <Button
                                            text="Save"
                                            icon="check"
                                            onClick={() => {
                                                setIsModalVisible(true);  // Show popup first
                                            }}
                                            stylingMode="contained"
                                            type="default"
                                            hint='Save'
                                        />
                                        :
                                        ""
                                }
                                &nbsp;&nbsp;

                                {!iom?.iomId ?
                                    //Add IOM
                                    <Button
                                        text={getButtonText()}
                                        icon="check"
                                        onClick={(e) => {
                                            let iomStatus = 3
                                            addNewIoM(iomStatus)
                                        }}
                                        stylingMode="contained"
                                        type="default"
                                        hint={
                                            getButtonText() === 'Send for Verification' ? 'Send for Verification' :
                                                getButtonText() === 'Send for Recommendation' ? 'Send for Recommendation' :
                                                    getButtonText() === 'Send for Approval' ? 'Send for Approval' : 'Send'
                                        }
                                    />
                                    : //Update IOM
                                    iomData?.createdByUserId === user?.userId && iomData?.iomStatusId === 8 || iomData?.iomStatusId === 4
                                        ?
                                        <Button
                                            text={
                                                iomData?.nextUserStatusId === 1 ? 'Send for Approval' :
                                                    iomData?.nextUserStatusId === 2 ? 'Send for Recommendation' :
                                                        iomData?.nextUserStatusId === 7 ? 'Send for Verification' : "Send"
                                            }
                                            icon="check"
                                            onClick={(e) => {
                                                let iomStatus = 3
                                                addNewIoM(iomStatus)
                                            }}
                                            stylingMode="contained"
                                            type="default"
                                            hint={
                                                iomData?.nextUserStatusId === 1 ? 'Send for Approval' :
                                                    iomData?.nextUserStatusId === 2 ? 'Send for Recommendation' :
                                                        iomData?.nextUserStatusId === 7 ? 'Send for Verification' : "Send"
                                            }
                                        />
                                        :
                                        //Edit IOM
                                        <Button
                                            text="Save"
                                            icon="check"
                                            onClick={() => {
                                                setIsUpdateModalVisible(true);  // Show popup first
                                            }}
                                            stylingMode="contained"
                                            type="default"
                                            hint='Save'
                                        />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="form-group">
                                    <label>
                                        Project <span className="text-danger">*</span>
                                    </label>
                                    <SelectBox
                                        //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                        dataSource={projectDropdownData}
                                        valueExpr="id"
                                        displayExpr="name"
                                        className="form-control"
                                        placeholder="Select"
                                        searchEnabled
                                        showClearButton={true}
                                        value={iom?.projectId}
                                        readOnly={(!iomData) ? false : (iomData?.iomStatusId === 8 && iomData?.createdByUserId === user?.userId) ? false : true}
                                        onValueChanged={(e) => {
                                            handleFormData("projectId", e?.value);
                                            //GetWorkFlowForApprovers(iom?.categoryId, e?.value, iom?.departmentId);
                                        }}
                                    />
                                    {errors?.projectId && <span className="error invalid-feedback">{errors?.projectId}</span>}
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="form-group">
                                    <label>
                                        Category <span className="text-danger">*</span>
                                    </label>
                                    <SelectBox
                                        dataSource={formCategoryDropdownData || []}
                                        valueExpr="id"
                                        displayExpr="name"
                                        className="form-control"
                                        placeholder="Select"
                                        searchEnabled
                                        showClearButton={true}
                                        value={iom?.categoryId}
                                        //disabled={!iom?.projectId}
                                        readOnly={(!iomData) ? false : (iomData?.iomStatusId === 8 && iomData?.createdByUserId === user?.userId) ? false : true}
                                        onValueChanged={(e) => {
                                            handleFormData("categoryId", e?.value);
                                            // GetWorkFlowForApprovers(e?.value, iom?.projectId, iom?.departmentId);
                                        }}
                                    />
                                    {errors?.categoryId && <span className="error invalid-feedback">{errors?.categoryId}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <div className="form-group">
                                    <label>
                                        Subject <span className="text-danger">*</span>
                                    </label>
                                    <TextBox
                                        value={iom?.subject}
                                        onValueChanged={(e) => handleFormData("subject", e.value)}
                                        placeholder="Enter subject"
                                        readOnly={
                                            !iomData
                                                ? false
                                                : ((iomData?.iomStatusId === 8 || iomData?.iomStatusId === 4)
                                                    && iomData?.createdByUserId === user?.userId)
                                                    ? false
                                                    : true
                                        }
                                    />
                                    {errors?.subject && <span className="error invalid-feedback">{errors?.subject}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="form-group">
                                    <label>IOM Content<span className="text-danger"> *</span></label>
                                    <style>
                                        {`.jodit .jodit-status-bar__item:last-child { display: none !important; }`}
                                    </style>
                                    <JoditEditor
                                        ref={editor}
                                        value={content}
                                        config={{
                                            ...config,
                                            readonly: (!iomData) ? false : ((iomData?.iomStatusId === 8 || iomData?.iomStatusId === 4) && iomData?.createdByUserId === user?.userId) ? false : true
                                        }}
                                        showCharsCounter={true}
                                        tabIndex={1}
                                        onBlur={(newContent) => setContent(newContent)}
                                    //onChange={handleEditorChange}
                                    />
                                    {errors?.iomMessage && <span className="error invalid-feedback">{errors?.iomMessage}</span>}
                                </div>
                            </div>
                        </div>
                        <div className='mb-1'>
                            <div className='form-group'>{/* <span onClick={() => { console.log(files) }}>console</span> */}
                                <label htmlFor="fileUpload" className='btn btn-outline-primary mb-1' style={{ cursor: 'pointer' }} title='Attachment'> <i class="fas fa-plus"></i> Attachment </label>
                                <input
                                    id="fileUpload"
                                    type="file"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />&nbsp;&nbsp;<small><Icon icon="ci:info" width="16" height="16" style={{ position: "relative", top: "-2px" }} /> Total attachment size must not exceed 300 MB.</small></div>
                            <div className='attachment-container'>
                                {files?.map((file, idx) => (
                                    <div
                                        key={idx}
                                        className='attachment-item'
                                    >
                                        <div class="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}>
                                            <div className='attachment-name'
                                                onClick={() => {
                                                    if (file?.filePath) {
                                                        const fileUrl =
                                                            process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                                            file?.filePath;
                                                        window.open(fileUrl, '_blank');
                                                    }
                                                }}>
                                                {file?.name}
                                            </div>
                                            <button
                                                className='btn pt-0 pb-0 pr-0'
                                                onClick={() => handleFileRemove(idx)}
                                            >
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                        <div className='small'>
                                            {(file?.size / 1024).toFixed(0)}kb
                                        </div>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row">
                            {iomApprovers?.[0]?.actionTypeId === 8 ? "" :
                                <>
                                    <div className="col-lg-4 col-md-12 col-sm-4">
                                        <div className='form-group'>
                                            {iomApprovers?.[0]?.actionTypeId === 8 ? ("") : (<label>Prepared By</label>)}
                                            {iomData?.iomId ? (
                                                <TextBox
                                                    className="form-control"
                                                    placeholder="Enter name"
                                                    showClearButton={false}
                                                    //value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                                                    value={iomData?.fromUser + " (" + iomData?.fromUserDesignation + ")"}
                                                    readOnly={true}
                                                //onValueChanged={(e) => handleUserChange(e, "employeeId")}
                                                />)
                                                :
                                                iomApprovers?.[0]?.actionTypeId === 8 ? (
                                                    "")
                                                    :
                                                    (<TextBox
                                                        className="form-control"
                                                        placeholder="Enter name"
                                                        showClearButton={false}
                                                        value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                                                        //value={iomData?.fromUser + " (" + iomData?.fromUserDesignation + ")"}
                                                        readOnly={true}
                                                    //onValueChanged={(e) => handleUserChange(e, "employeeId")}
                                                    />)
                                            }
                                            {/* {errors?.regards && <span className="text-danger">{errors?.regards}</span>} */}
                                        </div>
                                    </div>
                                </>
                            }

                            {iomData?.iomId ? (
                                iomApproversByWorkflow?.map((stage, index) => (
                                    <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                        <div className="w-100">
                                            <label className="form-label">{stage?.actionTypeName}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={`${stage?.userName} (${stage?.designationName})`}
                                                readOnly
                                            />

                                        </div>
                                    </div>
                                ))
                            ) : (
                                iomApproversByWorkflow?.map((stage, index) => (
                                    <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                        <div className="w-100">
                                            <label className="form-label">{stage?.actionTypeName}</label>
                                            {stage?.approvers?.map((approver, i) => (
                                                <input
                                                    key={i}
                                                    type="text"
                                                    className="form-control"
                                                    value={`${approver?.userName} (${approver?.designationName})`}
                                                    readOnly
                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))
                            )
                            }
                        </div>
                        <div className="row">
                        </div>
                    </div>
                </div>
            </div>
            <Popup
                visible={showPopup}
                onHiding={() => setShowPopup(false)}
                dragEnabled={false}
                //closeOnOutsideClick={true}
                showTitle={true}
                title="Add Approver"
                className='custom-popup-medium'
                height="auto"
                weight="auto"
            >
                <div>
                    <div className="form-group">
                        <label>
                            Department <span className="text-danger">*</span>
                        </label>
                        <SelectBox
                            dataSource={departmentDropdownData}
                            valueExpr="id"
                            displayExpr="name"
                            className="form-control"
                            placeholder="Select"
                            searchEnabled
                            showClearButton={true}
                            value={iom?.departmentId}
                            onValueChanged={(e) => {
                                handleFormData("departmentId", e?.value);
                                getUsersByDepartmentId(e?.value);
                                setDepartmentError('');
                            }}
                        />
                        {departmentError && <div className="error invalid-feedback">{departmentError}</div>}
                    </div>
                    <div className="form-group">
                        <label>
                            User <span className="text-danger">*</span>
                        </label>
                        <SelectBox
                            dataSource={departmentUserDropdownData}
                            valueExpr="id"
                            displayExpr="nameDesignation"
                            className="form-control"
                            placeholder="Select"
                            searchEnabled
                            showClearButton={true}
                            value={iom?.departmentUserId}
                            onValueChanged={(e) => {
                                const selectedUser = e.component?.option('selectedItem');
                                handleFormData("departmentUserId", e?.value);
                                handleFormData("departmentUserName", selectedUser?.nameDesignation);
                                handleFormData("userDesignationId", selectedUser?.designationId);
                                setUserError('');
                            }}
                        />
                        {userError && <div className="error invalid-feedback">{userError}</div>}
                    </div>
                </div>
                <div className='text-right'>
                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setShowPopup(false)
                            setDepartmentError(null)
                            setUserError(null)
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="default"
                        onClick={() => {
                            handleSubmitApprover();
                        }
                        }
                        className="btn btn-primary btn-sm"
                    />
                </div>

            </Popup>
            <Popup
                visible={isModalVisible}
                onHiding={() => setIsModalVisible(false)}
                dragEnabled={false}
                showTitle={true}
                title="Update"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >

                <div className='popup-body'>
                    <label>Remark <span className="text-danger">*</span></label>
                    <div className='form-group'>
                        <TextArea
                            value={remarks}
                            onValueChanged={(e) => setRemarks(e.value)}
                            height={90}
                            placeholder="Type your remarks..."
                        />
                        {error && (
                            <div style={{ color: "red", marginTop: 5 }}>{error}</div>
                        )}
                    </div>
                </div>
                <div className='text-right'>
                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>

            </Popup>
            <Popup
                visible={isUpdateModalVisible}
                onHiding={() => setIsUpdateModalVisible(false)}
                dragEnabled={false}
                showTitle={true}
                title="Update"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >

                <div className='popup-body'>
                    <label>Remark <span className="text-danger">*</span></label>
                    <div className='form-group'>
                        <TextArea
                            value={remarks}
                            onValueChanged={(e) => setRemarks(e.value)}
                            height={90}
                            placeholder="Type your remarks..."
                        />
                        {error && (
                            <div style={{ color: "red", marginTop: 5 }}>{error}</div>
                        )}
                    </div>
                </div>
                <div className='text-right'>
                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsUpdateModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleUpdateSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {loading && <Loader loadingMessage={""} />}
        </Fragment >
    )
}
